let Diagnosis = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;

    /**
     * 获取症状逻辑图首页
     * @param {any} success
     * @param {any} error
     */
    this.Diagnosis = function (success, error) {
        var url = ServiceBaseAddress + '/api/Diagnosis';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 获取症状逻辑图详情
     * @param {any} success
     * @param {any} error
     */
    this.Detail = function (params,success, error) {
        var url = ServiceBaseAddress + '/api/Diagnosis/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { Diagnosis }